export const PolicyLinks = {
  terms: 'https://vista.com/terms-and-conditions',
  privacy: 'https://vista.com/privacy-and-cookie-policy',
  legal: 'https://vista.com/legal-notice',
}
